import {
    TggColour,
    TggLegacyColours,
    TggPrimitives,
    TggTransparentColor,
} from './primitives.type';

export const energyBlue = {
    50: '#E6EFFF',
    100: '#CDDFFF',
    200: '#9DBFFF',
    300: '#6D9EFC',
    400: '#3D7AF6',
    500: '#0050EF',
    600: '#0039B1',
    700: '#002478',
    800: '#001042',
    900: '#000214',
} as TggColour;

export const electricGreen = {
    100: '#F0FFDE',
    200: '#E0FFBB',
    300: '#D1FF95',
    400: '#C2FF67',
    500: '#B2FF00',
    600: '#83BE00',
    700: '#578000',
    800: '#2F4800',
    900: '#0C1600',
} as TggColour;

export const darkBlue = {
    50: '#E2E6F1',
    100: '#C5CCE2',
    200: '#8E9BC4',
    300: '#5B6CA6',
    400: '#2D3D86',
    500: '#0E0066',
    600: '#07004A',
    700: '#03002F',
    800: '#010017',
    900: '#000004',
} as TggColour;

export const cyan = {
    100: '#D8EBFF',
    200: '#B2D6FF',
    300: '#8AC1FF',
    400: '#61ABFF',
    500: '#2E94FF',
    600: '#1F6DBE',
    700: '#124880',
    800: '#062648',
    900: '#010816',
} as TggColour;

export const neutral = {
    0: '#FFFFFF',
    25: '#FAFBFF',
    50: '#F4F7FC',
    100: '#E9EEF7',
    200: '#E3E8F2',
    300: '#D9E0EF',
    400: '#CCD7EE',
    500: '#B5C1DA',
    600: '#A3AEC6',
    700: '#7F889B',
    800: '#5D677D',
    900: '#3B475F',
    950: '#1B202B',
    1000: '#000000',
} as TggColour;

export const orange = {
    100: '#FFEED9',
    200: '#FFDBB3',
    300: '#FFCB8A',
    400: '#FFB95C',
    500: '#FEA600',
    600: '#BD7A00',
    700: '#805100',
    800: '#472B00',
    900: '#160A00',
} as TggColour;

export const pink = {
    100: '#FFDFF9',
    200: '#FFBEF2',
    300: '#FF9CEB',
    400: '#FE76E3',
    500: '#F848DB',
    600: '#B833A2',
    700: '#7C1F6D',
    800: '#450D3C',
    900: '#150211',
} as TggColour;

export const purple = {
    100: '#E7E2FF',
    200: '#CFC4FF',
    300: '#B9A5FF',
    400: '#A485FF',
    500: '#9162FF',
    600: '#6A47BE',
    700: '#462D80',
    800: '#251648',
    900: '#070316',
} as TggColour;

export const red = {
    100: '#FFDEDE',
    200: '#FFBCBD',
    300: '#FF999C',
    400: '#FF747D',
    500: '#FB465D',
    600: '#BA3243',
    700: '#7E1E2A',
    800: '#460D14',
    900: '#150203',
} as TggColour;

export const yellow = {
    100: '#FFFFE6',
    200: '#FFFCB',
    300: '#FEFFAE',
    400: '#FFFF8E',
    500: '#FFFF67',
    600: '#BEBE4B',
    700: '#808030',
    800: '#484817',
    900: '#161604',
} as TggColour;

export const ragRed = {
    50: '#FFECE9',
    100: '#FFDAD3',
    200: '#FDB4A7',
    300: '#F78D7C',
    400: '#EE6350',
    500: '#E22918',
    600: '#A81C0F',
    700: '#710F07',
    800: '#3E0502',
    900: '#120100',
} as TggColour;

export const ragAmber = {
    50: '#FEF5EC',
    100: '#FCEBD9',
    200: '#F9D6B3',
    300: '#F5C18B',
    400: '#FOAC61',
    500: '#EA9628',
    600: '#AE6E1B',
    700: '#75490F',
    800: '#412604',
    900: '#130801',
} as TggColour;

export const ragGreen = {
    50: '#EAF6E9',
    100: '#D6EDD4',
    200: '#ADDAA8',
    300: '#83C77D',
    400: '#54B34E',
    500: '#009F00',
    600: '#007500',
    700: '#004D00',
    800: '#002900',
    900: '#000900',
} as TggColour;

export const blackTransparent = {
    0: 'rgba(0, 0, 0, 0)',
    10: 'rgba(0, 0, 0, 0.1)',
    20: 'rgba(0, 0, 0, 0.2)',
    30: 'rgba(0, 0, 0, 0.3)',
    40: 'rgba(0, 0, 0, 0.4)',
    50: 'rgba(0, 0, 0, 0.5)',
    60: 'rgba(0, 0, 0, 0.6)',
    70: 'rgba(0, 0, 0, 0.7)',
    80: 'rgba(0, 0, 0, 0.8)',
    90: 'rgba(0, 0, 0, 0.9)',
    100: 'rgba(0, 0, 0, 1)',
} as TggTransparentColor;

export const legacy: TggLegacyColours = {
    brand: {
        legacyCyan: '#2E94FF',
        darkBlue: '#0E0066',
        electricGreen: '#B2FF00',
    },
    tint: {
        electricTint: '#F7FFE5',
        cyan5: '#EEF3F9',
        cyan10: '#E5EFFA',
        cyan17: '#D7EBFA',
        cyan20: 'rgba(46, 148, 255, 0.2)',
        cyan22: '#CCE3FA',
        darkBlue20: 'rgba(14, 0, 102, 0.2)',
    },
    rag: {
        red: '#E22918',
        redTint: 'rgba(226, 41, 24, 0.2)',
        amber: '#EA9628',
        amberTint: 'rgba(234, 150, 40, 0.2)',
        green: '#08BE07',
        greenTint: 'rgba(8, 190, 7, 0.2)',
    },
};

export const lightPrimitives: TggPrimitives = {
    electricGreen,
    energyBlue,
    darkBlue,
    neutral,
    orange,
    pink,
    purple,
    cyan,
    red,
    yellow,
    ragRed,
    ragAmber,
    ragGreen,
    blackTransparent,
    // Product colours are an outlier that don't have corresponding swatch values
    product: {
        ultimateOrangeRed: '#F04F29',
        offPeakSilverGrey: '#EFEFEF',
    },
    legacy,
};
